import store from "@/store/store.js";
import * as userBooksData from "@/services/userBooksData.js";
import Vue from "vue";
import * as userTsiyun from "@/services/userTsiyuns.js";
import { getFSResultsPages, getBookName } from "@/services/bookData.js";
import { treeBooks } from "@/store/modules/books.js";
import { permissionsEnum, getBookLicenseData } from "@/services/license";
import config from "@/config/general.js";
import { createFreeSearchBookListStore } from "@/store_pinia";
import mef from "@/services/mefotzar";
import { getMefoSectionTitle } from "@/services/mefo/mefo.js";
const mefData = Object.values(mef);
const mefSectionListData = new Map();
export const namespaced = true;

export const state = function () {
  ////////WARNING --- THIS MAY FAIL IN VUE 3 AND STILL CONSUME MEMORY
  return {
    id: "",
    title: "",
    alwaysShow: false,
    customTitle: "",
    book: 0,
    page: 0,
    override: false,
    fitToWidth: true,
    zoom: 100,
    scrollPosition: 0,
    drawData: { rects: {}, fs: {} },
    userTsiyunim: [],
    allRecentPages: [],
    personalAdditions: { comments: [], keys: [], markers: [], links: [] },
    scrollTo: 1,
    pageHeight: 0,
    activeTsiyun: 0,
    activeUserTsiyun: 0,
    activePage: 0,
    resize: false,
    bookFit: "width",
    tempPage: 0,
    stopPrinting: false,
    winWidth: document.body.clientWidth * 0.95,
    winHeight: document.body.clientWidth * 0.95,
    minimize: false,
    txtBook: false,
    openFs: false,
    fsFinished: false,
    fsChange: 0,
    manualClickPage: 0,
    addingLink: false,
    firstLink: null,
    secondLink: null,
    fsTotal: 0,
    editExtens: false,
    itemEdit: {},
    openEditor: false,
    SHAS_SECTIONS: null,
    SHAS_SECTION_LIST_ID: null,
    shasSecSelected: [],
    rambamSecSelectedTitle: "",
    pinned: false,
    mefFirstPage: 0,
    mefLastPage: 0,

    masks: [],
    tabWidth: 0,
    showMask: true,
    imageEdit: {
      blur: 0,
      brightness: 100,
      contrast: 100,
      dropshadow: 0,
      grayscale: 0,
      huerotate: 0,
      invert: 0,
      opacity: 0,
      saturate: 0,
      sepia: 0,
      enable: false,
      changed: 0,
    },
    license: [],
    showEmptyPage: false,
    react: 0,
    pagesLoaded: true,
    pdfBook: false,
    pagesPanelOpen: true,
    newComment: {},
    editComment: {},
    newKey: {},
    scrollInPage: 0,
    personalAdditionsPanelOpen: "",
    bookmarkPosition: -1,
    bookmarkStatus: "off", //can be in 3 modes on|init|off , init mean set to top current shown page
    pageId: "",
    zoomMode: false,
    scrollPageToXY: { x: 0, y: 0 },
    mefoOn: false,
    navigatePartsOpen: null,
    startWithMefo: false,
  };
};

export const mutations = {
  CLEAR_TAB(state) {
    state.pages = [];
    state.userTsiyunim = [];
    state.allRecentPages = [];
    state.tsiyunim = [];
    state.personalAdditions = {
      comments: [],
      keys: [],
      markers: [],
      links: [],
    };
  },
  SET_ROTATE_PAGE(state, value) {
    try {
      let rotateDegrees = state.pages[value].rotate
        ? state.pages[value].rotate + 90
        : 90;
      if (rotateDegrees == 360) rotateDegrees = 0;
      Vue.delete(state.pages[value], "rotate");
      Vue.set(state.pages[value], "rotate", rotateDegrees);
    } catch (ex) {
      console.log("cannot rotate", ex);
    }
  },
  SET_PIN(state, value) {
    state.pinned = value;
  },
  TOGGLE_PIN(state) {
    state.pinned = !state.pinned;
  },
  SET_FS_DATA(state, fs) {
    Vue.set(state.drawData, "fs", fs);
  },
  OPEN_FS(state, val) {
    state.openFs = val;
  },
  SET_CUSTOM_TITLE(state, title) {
    Vue.set(state, "customTitle", title);
  },
  SET_TITLE(state, title) {
    Vue.set(state, "title", title);
  },
  SET_TXT_BOOK(state, value) {
    state.txtBook = value;
  },
  SET_BOOK_FIT(state, { fit }) {
    state.bookFit = fit;
  },
  TRIGGER_RESIZE(state) {
    state.resize = !state.resize;
  },
  ADD_TAB(state, tabData) {
    state.id = tabData.id;
    state.book = tabData.book;
    state.page = tabData.page || [];
    state.title = tabData.title;
    state.scrollPosition = tabData.scrollPosition;
    state.override = tabData.override;
    state.drawData = tabData.drawData;
    state.tsiyunim = tabData.tsiyunim || [];
    state.pages = tabData.pages;
    state.userTsiyunim = tabData.userTsiyuns;
    state.allRecentPages = tabData.allRecentPages || [];
    state.personalAdditions = tabData.personalAdditions;
    state.pageHeight = tabData.pageHeight;
    state.winHeight = tabData.winHeight;
    state.winWidth = tabData.winWidth;
    state.volumes = tabData.volumes;
    state.masks = tabData.masks;
    if (state.SHAS_SECTION_LIST_ID) {
      mefSectionListData.delete(state.SHAS_SECTION_LIST_ID);
      state.SHAS_SECTION_LIST_ID = null;
    }
    if (state.pages && state.pages[0])
      state.pageId = state.pages[state.page - 1]?.name;
  },
  SET_OVERRIDE(state, override) {
    state.override = override;
  },
  SET_TSIYUNIM(state, tsiyunim) {
    state.react++;
    state.tsiyunim = tsiyunim;
  },
  SET_PAGES(state, pages) {
    state.react++;
    state.pages = pages;
    state.pageId = state.pages[state.page - 1]?.name;
  },
  SET_BOOK(state, book) {
    state.book = book;
  },
  SET_BOOK_MMTS(state, mmts) {
    if (mmts && mmts.length > 0) mmts[0] = 0; //TEMP avoid mm in first page
    state.MM = mmts;
  },
  SET_SHAS_SECTIONS(state, sections) {
    // state.SHAS_SECTIONS = sections;
    if (state.SHAS_SECTION_LIST_ID)
      mefSectionListData.delete(state.SHAS_SECTION_LIST_ID);
    if (!sections) {
      state.SHAS_SECTION_LIST_ID = null;
      return;
    }
    state.SHAS_SECTION_LIST_ID = Math.random(1 % 1000000);
    mefSectionListData.set(state.SHAS_SECTION_LIST_ID, sections);
    let masData = mefData.find((m) => m.bookid == state.book);
    if (masData && masData.firstPage) {
      state.mefFirstPage = masData.firstPage + 1;
      state.mefLastPage = masData.firstPage + masData.count + 1;
    }
    // state.mefFirstPage =
    //   mefData.find((m) => m.bookid == state.book)?.firstPage + 1 || 0;
  },
  SET_SHAS_SECTION_SELECTED(state, payload) {
    if (payload.add) state.shasSecSelected.push(payload.section);
    else {
      state.shasSecSelected = [payload.section];
    }
    if (payload.section.id >= 1000000) {
      // get title of rambam section
      getMefoSectionTitle(payload.section.id).then((title) => {
        state.rambamSecSelectedTitle = title;
      });
    }
  },
  SET_SECTION_SELECTED_TITLE(state) {
    state.sectio;
  },
  SET_PAGE(state, page) {
    state.page = page;
    if (state.pages && state.pages[0])
      state.pageId = state.pages[state.page - 1]?.name;
  },
  SET_USER_TSIYUNS(state, userTsiyuns) {
    state.react++;
    state.userTsiyunim = userTsiyuns;
  },
  SET_RECENT_PAGES(state, allRecentPages) {
    const Prop = allRecentPages.page ? "page" : "pageId";
    /*     const lastOne = state.allRecentPages.filter(
      (a) => a[Prop] == allRecentPages[Prop]
    ); */
    try {
      if (Prop == "pageId" && !allRecentPages.pageId)
        allRecentPages.pageId = allRecentPages.pagedata[0].pageId;
    } catch {}

    if (!state.allRecentPages) state.allRecentPages = [];
    else {
      let tmp = state.allRecentPages.filter(
        (a) => a[Prop] != allRecentPages[Prop]
      );

      if (tmp.length > 5) tmp.pop();
      state.allRecentPages = [allRecentPages, ...tmp];
    }
    state.react++;
  },
  DELETE_RECENT_PAGE(state, position) {
    userBooksData.deleteUserRecentPage(state.book, position.id);
    state.allRecentPages = state.allRecentPages.filter(
      (tsiyun) =>
        tsiyun.pageId !== position &&
        tsiyun.id !== position &&
        tsiyun.page !== position &&
        tsiyun.position !== position
    );
  },
  UPDATE_RECENT_PAGE(state, position) {
    const found = state.allRecentPages.find(
      (a) => a.position === position.position
    );
    if (found) {
      found.sticky = !found.sticky;
    }
    state.react++;
  },
  ADD_USER_TSIYUN(state, r) {
    state.userTsiyunim.push(r);
    state.userTsiyunim.sort((a, b) => (a.page > b.page ? 1 : -1));
  },
  UPD_USER_TSIYUN(state, r) {
    try {
      state.userTsiyunim.find((t) => t.id === r.id).title = r.title;
    } catch (ex) {}
  },
  DEL_USER_TSIYUN(state, { id }) {
    state.userTsiyunim = state.userTsiyunim.filter((tsiyun) => tsiyun.id != id);
  },
  SET_SCROLLTO(state, page) {
    state.scrollTo = page;
  },
  INC_SCROLLTO(state, inc) {
    state.scrollTo = state.page + inc;
  },
  SET_PAGE_HEIGTH(state, pageHeight) {
    state.pageHeight = pageHeight;
  },
  SET_LICENSE(state, license) {
    if (!license) license = [];

    //check if this book has MEF license
    let bk = store.getters["books/getBookbyId"](state.book, true);
    if (bk) {
      let bookPermissions = bk.permissions;
      if (bookPermissions & permissionsEnum.MEF_OTZAR.value) {
        license.push({ id: 12, title: "MEF_OTZAR" });
      }
    }

    state.license = license;
  },
  SET_ACTIVE_PAGE(state, pos) {
    state.activePage = pos;
  },
  SET_ACTIVE_TSIYUN(state, pos) {
    state.activeTsiyun = pos;
  },
  SET_ACTIVE_USER_TSIYUN(state, pos) {
    state.activeUserTsiyun = pos;
  },
  SET_ZOOM(state, zoom) {
    state.zoom = zoom;
  },
  ADD_RECT(state, data) {
    let rects = state.drawData?.rects;
    if (!rects) rects = [];
    rects = rects.filter((r) => r.page != data.page);
    rects.push(data);
    Vue.set(state.drawData, "rects", rects);
  },
  TOGGLE_MEFO_ON(state) {
    if (state.mefoOn == undefined) state.mefoOn = false;
    else state.mefoOn = !state.mefoOn;
  },
  SET_MEFO_ON(state, value) {
    state.mefoOn = value;
  },
};

export const actions = {
  toggleMefoOn({ commit }) {
    commit("TOGGLE_MEFO_ON");
  },
  setMefoOn({ commit }, value) {
    commit("SET_MEFO_ON", value);
  },
  closeTabEvent({ state }) {
    if (state.SHAS_SECTION_LIST_ID && mef[state.book]) {
      mefSectionListData.delete(state.SHAS_SECTION_LIST_ID);
    }
  },
  clearTab({ commit }) {
    commit("CLEAR_TAB");
  },
  setRotatePage({ commit }, page) {
    commit("SET_ROTATE_PAGE", page);
  },
  setPin({ commit }, value) {
    commit("SET_PIN", value);
  },
  togglePin({ commit }) {
    commit("TOGGLE_PIN");
  },
  setCustomTitle({ commit }, title) {
    commit("SET_CUSTOM_TITLE", title);
  },
  setTitle({ commit }, title) {
    commit("SET_TITLE", title);
  },
  setTxtBook({ commit }, value) {
    commit("SET_TXT_BOOK", value);
  },
  setBookFit({ commit }, fit) {
    commit("SET_BOOK_FIT", {
      fit,
    });
  },
  openFs({ commit }, val) {
    commit("OPEN_FS", val);
  },
  triggerResize({ commit }) {
    commit("TRIGGER_RESIZE");
  },
  setZoom({ commit }, { zoom }) {
    commit("SET_ZOOM", zoom);
  },
  setTabData({ commit }, tabData) {
    commit("ADD_TAB", tabData);
  },
  setOverride({ commit }, override) {
    commit("SET_OVERRIDE", override);
  },
  setTsiyunim({ commit }, payload) {
    let tsiyunim = payload && payload.tsiyunim ? payload.tsiyunim : [];
    tsiyunim.sort((a, b) => a.yesodPosition - b.yesodPosition);
    commit("SET_TSIYUNIM", tsiyunim);
  },
  setPages({ commit }, payload) {
    let pages = payload && payload.pages ? payload.pages : [];
    return new Promise(function (resolve, reject) {
      commit("SET_PAGES", pages);
      resolve(true);
    });
  },
  setPage({ commit }, page) {
    commit("SET_PAGE", page);
  },
  setBook({ commit }, book) {
    commit("SET_BOOK", book);
  },
  setBookMM({ commit }, mmts) {
    commit("SET_BOOK_MMTS", mmts);
  },
  setShasSections({ commit }, sections) {
    commit("SET_SHAS_SECTIONS", sections);
  },
  setShasSecSelected({ commit }, payload) {
    commit("SET_SHAS_SECTION_SELECTED", payload);
  },
  setUserTsiyuns({ commit }, userTsiyuns) {
    commit("SET_USER_TSIYUNS", userTsiyuns);
  },
  setRecentPages({ commit }, allRecentPages) {
    if (allRecentPages.sticky == undefined) allRecentPages.sticky = 0;
    try {
      commit("SET_RECENT_PAGES", allRecentPages);
    } catch (ex) {
      console.log(ex);
    }
  },
  delRecentPage({ commit }, position) {
    commit("DELETE_RECENT_PAGE", position);
  },
  async updateRecentPage({ commit, state }, position) {
    await userBooksData.addUpdateUserRecentBook({
      bookId: state.book,
      pageId: position.position,
      sticky: position.sticky == 0 ? 1 : 0,
    });
    commit("UPDATE_RECENT_PAGE", position);
  },
  setScrollTo({ commit }, page) {
    return new Promise(function (resolve, reject) {
      commit("SET_SCROLLTO", page);
      resolve();
    });
  },
  incScrollTo({ commit }, inc) {
    commit("INC_SCROLLTO", inc);
  },
  setPageHeight({ commit }, pageHeight) {
    commit("SET_PAGE_HEIGTH", pageHeight);
  },
  setLicense({ commit }, license) {
    return new Promise((res, rej) => {
      const licsArray = [];
      //create array of licenses
      Object.keys(config.licensePackages).forEach((lic) => {
        if ((config.licensePackages[lic] & (license >> 1)) > 0)
          licsArray.push({ title: lic });
      });

      commit("SET_LICENSE", licsArray);
      res();
    });
  },
  setActivePage({ commit }, pos) {
    commit("SET_ACTIVE_PAGE", pos);
  },
  setActiveTsiyun({ commit }, pos) {
    commit("SET_ACTIVE_TSIYUN", pos);
  },
  setActiveUserTsiyun({ commit }, pos) {
    commit("SET_ACTIVE_USER_TSIYUN", pos);
  },
  addUserTsiyun({ commit }, { bookId, pageId, title, page }) {
    return new Promise(function (resolve, reject) {
      userTsiyun.addUserTsiyun({ bookId, pageId, title, page }).then((r) => {
        commit("ADD_USER_TSIYUN", { ...r.data, page });
        resolve(true);
      });
    });
  },
  updateUserTsiyun({ commit }, { id, title, page }) {
    return new Promise(function (resolve, reject) {
      userTsiyun.updateUserTsiyun(id, title).then((r) => {
        commit("UPD_USER_TSIYUN", { ...r.data, page });
        resolve(true);
      });
    });
  },
  delUserTsiyun({ commit }, { id }) {
    return userTsiyun.deleteUserTsiyun(id).then((r) => {
      if (r.data > 0) commit("DEL_USER_TSIYUN", { id });
    });
  },
  setMinimize({ state }, mode) {
    state.minimize = mode;
  },
  toggleMinimize({ state }) {
    state.minimize = !state.minimize;
  },
  setRects({ commit }, { page, rect }) {
    commit("ADD_RECT", { page, rect });
  },
  refreshFS({ dispatch, state, commit }, fsData) {
    let isList = createFreeSearchBookListStore().isSavedList;
    if (fsData?.fs != undefined) {
      commit("SET_FS_DATA", fsData);
      state.pages.forEach((page) => {
        Vue.delete(page, "words");
      });
      state.fsChange++;
      if (fsData?.fs != "0") {
        let _vm = this;
        getFSResultsPages(
          { fs: fsData },
          state.pages,
          state.book,
          state.id,
          isList
        ).then((p) => {
          let fsPage = state.pages.filter((page) => page.words != undefined);

          if (
            state.page != -1 &&
            fsPage.find((p) => p.position == state.page)
          ) {
            dispatch(`setScrollTo`, state.page);
            //  Vue.$nextTick(() => {
            state.fsChange++;
            //   });
          } else if (fsPage.length > 0) {
            dispatch(`setScrollTo`, {
              page: fsPage[0].position,
              offset: 0, //offset should be top of first result
            });
          }
        });
      }
    }
  },
  setBookmarkPosition({ state }, pos) {
    state.bookmarkPosition = pos;
  },
  setBookmarkStatus({ state }, status) {
    state.bookmarkStatus = status;
  },
};

export const getters = {
  isMefoOn(state) {
    return state.mefoOn == undefined || state.mefoOn == true ? true : false;
  },
  noEmptyPages(state) {
    let x = state.react;
    return state.pages.filter((p) => !p.empty);
  },
  getMefoSectionsList(state) {
    return (id) => mefSectionListData.get(id);
  },
  getBookLicense(state) {
    return state.license || [];
  },
  isMefShas(state) {
    return state.SHAS_SECTION_LIST_ID;
  },
  getZoom(state) {
    return state.zoom;
  },
  maxFreePages(state, getters, rootState) {
    let isPackageBook = packages.includes(
      getters["getBookPermission"].bookPermissions
    );

    return getters["itimLebina75"]
      ? 8
      : isPackageBook ||
        rootState.user.userType == "GUEST" ||
        getters["itimLebina"]
      ? globalThis.DEV_ALLOWED_PAGES_PACKAGE
      : globalThis.DEV_ALLOWED_PAGES_BASIC;
  },
  getBookPermission(state) {
    return getBookLicenseData(state.license);
  },
  isBookAllowedToUser(state, getters, rootState, rootGetters) {
    if (globalThis.SERVER_MODE == "offline") return true;
    let allowed = false;
    let mefConnection = rootGetters["user/hasMefConnection"];
    let otzarConnection = rootGetters["user/hasOtzarConnection"];

    let bookPermissions = getters["getBookPermission"].bookPermissions;
    /* 
    //good for online users but not for disk users
    if (
      (bookPermissions & permissionsEnum.OVADIA.value) ==
      permissionsEnum.OVADIA.value
    )
      return true; */
    allowed = bookPermissions & rootState.user.permissions;
    if (bookPermissions & permissionsEnum.FREE.value) allowed = true;
    if (!otzarConnection) {
      if (
        bookPermissions & permissionsEnum.MEF_OTZAR.value &&
        bookPermissions & rootState.user.permissions
      )
        allowed = true;
      else if (
        bookPermissions & permissionsEnum.GENERAL.value ||
        bookPermissions & permissionsEnum.SCHOOL.value
      )
        allowed = false;
    }

    return allowed;
  },
  bookPermissionsData(state, getters, rootState) {
    return getters["getBookPermission"].bookPermissionsData;
  },
  OZBook(state, getters) {
    return false;
    return (
      getters["getBookPermission"].bookPermissions ==
      permissionsEnum["OZ"].value
    ); //256;
  },
  itimLebina(state) {
    return itimLebinaBooks(state.book);
  },
  itimLebina75(state) {
    return itimLebina75Books(state.book);
  },
  getOpenEditor(state) {
    return state.openEditor;
  },
  getUserTsiyuns(state) {
    return state.userTsiyunim;
  },
  getTabData(state) {
    let tabData = {};
    tabData.id = state.id;
    tabData.book = state.book;
    tabData.page = state.page;
    tabData.title = state.title;
    tabData.scrollPosition = state.scrollPosition;
    tabData.drawData = state.drawData;
    tabData.override = state.override;
    tabData.pages = state.pages;
    tabData.tsiyunim = state.tsiyunim;
    tabData.usertsiyuns = state.userTsiyunim;
    tabData.recentpage = state.allRecentPages || [];
    tabData.personalAdditions = state.personalAdditions;
    tabData.pageHeight = state.pageHeight;
    tabData.scrollTo = state.scrollTo;
    tabData.customTitle = state.customTitle;
    tabData.pinned = state.pinned;
    tabData.pageId = state.pageId;
    return tabData;
  },
  getPages(state) {
    let x = state.react;
    return state.pages;
  },
  getTsiyunim(state) {
    let x = state.react;
    return state.tsiyunim;
  },
  getUserTsiyuns(state) {
    let x = state.react;
    return state.userTsiyunim;
  },
  getRecentPages(state) {
    let x = state.react;
    if (!state.allRecentPages) {
      state.allRecentPages = [];
      return state.allRecentPages;
    }
    let data = [...state.allRecentPages];
    data.sort((a, b) => a.sticky - b.sticky);
    return state.allRecentPages;
  },
  isfirstTab(state) {
    return store.getters["tabsManager/getTabs"].indexOf(state.id) == 0;
  },
  getCurrentPageDBId(state) {
    return state.pages[state.page - 1];
  },
  getBook(state) {
    return state.book;
  },
  getPage(state) {
    return state.page;
  },
  getBookFit(state) {
    return state.bookFit;
  },
  getBookNameAndAuthor(state) {
    let b = treeBooks.get(treeBooks.root, state.book);
    if (!b) return "";
    return getBookName(b.name, b.volume, true) + " / " + b.mainAuthorName;
  },
  bookInFavorites(state, getters, rootState, rootGetters) {
    let b = treeBooks.get(treeBooks.root, state.book);
    return b != undefined ? b.favorite : false;
    //  let favorites = rootGetters["userFavoriteBooks/getFavoriteBooks"];
    // let book = state.book;

    // favorites = favorites.filter((favorite) => favorite.bookId == book);
    // return favorites.length > 0;
  },
  hasFsResults(state) {
    return (
      state.drawData?.fs?.fs != undefined &&
      state.drawData?.fs?.fs != "" &&
      state.drawData?.fs?.fs != "0"
    );
  },
  yesharimBook(state) {
    let bk = store.getters["books/getBookbyId"](state.book, true);
    if (!bk) return false;
    const perms = bk.permissions >> 1;
    let yehsarim = perms & permissionsEnum.YESHARIM.value;
    return yehsarim ? true : false;
  },
  ovadiaBook(state) {
    let bk = store.getters["books/getBookbyId"](state.book, true);
    if (!bk) return false;
    const perms = bk.permissions >> 1;
    let ovadia = perms & permissionsEnum.OVADIA.value;
    return ovadia ? true : false;
  },
  getBookmarkPosition(state) {
    return state.bookmarkPosition; //|| -1;
  },
  getBookmarkStatus(state) {
    return state.bookmarkStatus || "off";
  },
};

const packages = [
  0b1000, 0b10000, 0b100000, 0b1000000, 0b10000000, 0b100000000, 0b1000000000,
  0b1000000000000, 0b10000000000000, 0b100000000000000, 0b1000000000000000000,
  0b10000000000000000000, 0b100000000000000000000,
];

function itimLebinaBooks(bookId) {
  return [
    676856, 676855, 676854, 676853, 676852, 676851, 676850, 676849, 676848,
    676847, 676846, 676845, 676844, 676843, 676842, 676841, 676840, 676839,
    676838, 676837, 676836, 676835, 676834, 676833, 676832, 676831, 676830,
    676829, 676828, 676827, 676826, 676825, 676824, 676823, 676822, 676821,
    676820, 676819, 676818, 676817, 676816, 676815, 676814, 676813, 676812,
    676811, 676810, 676809, 676808, 676807, 676806, 676805, 676804, 676803,
    676802, 676801, 676800, 676799, 676798, 676797, 676796, 676795, 676794,
    676793, 676792, 676791, 676790, 676789, 676788, 676787, 676786, 676785,
    676784, 676783, 676782, 676781, 676780, 676779, 676778, 676777, 676776,
    676775, 687761, 687762, 687763, 687764, 687765, 687766, 687767, 687768,
    687769, 687770, 687771, 687772, 687773, 687774, 687775, 687776, 687777,
    687852, 687778, 687779, 687780, 687781, 687853, 687782, 687783, 687854,
    687784, 687786, 687785, 687787, 687788, 687789, 687790, 687791, 687792,
    687793, 687794, 687795, 687796, 687797, 687798, 687799, 687800, 687801,
    687802, 687855, 687856, 687803, 687804, 687806, 687805, 687857, 687858,
    687807, 687859, 687808, 687809, 687810, 687811, 687812, 687860, 687813,
    687814, 687815, 687816, 687817, 687818, 687819, 687820, 687861, 687821,
    687822, 687823, 687824, 687825, 687826, 687827, 687828, 687862, 687863,
    687864, 687829, 687831, 687830, 687832, 687833, 687834, 687835, 687836,
    687837, 687838, 687839, 687840, 687841, 687842, 687843, 687844, 687845,
    687846, 687847, 687865, 687848, 687866, 687849, 687850, 687851,
  ].includes(parseInt(bookId));
}

function itimLebina75Books(bookId) {
  return false; //we may want to use this functionality every year for luchot
  return [
    687761, 687762, 687763, 687764, 687765, 687766, 687767, 687768, 687769,
    687770, 687771, 687772, 687773, 687774, 687775, 687776, 687777, 687852,
    687778, 687779, 687780, 687781, 687853, 687782, 687783, 687854, 687784,
    687786, 687785, 687787, 687788, 687789, 687790, 687791, 687792, 687793,
    687794, 687795, 687796, 687797, 687798, 687799, 687800, 687801, 687802,
    687855, 687856, 687803, 687804, 687806, 687805, 687857, 687858, 687807,
    687859, 687808, 687809, 687810, 687811, 687812, 687860, 687813, 687814,
    687815, 687816, 687817, 687818, 687819, 687820, 687861, 687821, 687822,
    687823, 687824, 687825, 687826, 687827, 687828, 687862, 687863, 687864,
    687829, 687831, 687830, 687832, 687833, 687834, 687835, 687836, 687837,
    687838, 687839, 687840, 687841, 687842, 687843, 687844, 687845, 687846,
    687847, 687865, 687848, 687866, 687849, 687850, 687851,
  ].includes(parseInt(bookId));
}
